
import { Vue, Component } from 'vue-property-decorator';

import TopupComp from './TopUpComp.vue';

@Component({
  components: {
    TopupComp,
  },
})
export default class Topup extends Vue {}
